export default {
  Warnings: {
    warning_farm_disabled: {
      manager_farms: 'Manage farms',
      message_farm_disabled:
        'This farm is disabled, you will not be able to edit or create anything. Enable to use',
    },
  },
}
